import { getSubjectActivityType } from '@/api/teacher/campusActivities';

export default {
    state: {
        subjectList: [],
    },
    getters: {},
    mutations: {
        setSubjectList(state, subjectList) {
            state.subjectList = subjectList;
        },
    },
    actions: {
        async getSubjectList({ commit }, payload) {
            const res = await getSubjectActivityType(payload);
            res.data.forEach((item) => {
                item.text = item.subjectName;
                item.value = item.subject;
                item.activityInfo.forEach((ii) => {
                    ii.text = ii.activityType;
                    ii.value = ii.activityTypeValue;
                });
            });
            //const subjectList = await dispatch('getSubjectList');
            commit('setSubjectList', res.data);
        },
    },
};
